<template>
    <v-card flat class="program-card bordered d-flex flex-column">
        <div class="program-image">
            <router-link :to="to">
                <v-img v-ripple="{class: 'white--text'}" height="200" :src="program.image_url" />
            </router-link>
        </div>
        <div class="program-details d-flex flex-column align-stretch py-4 px-4 flex-grow-1">
            <div class="program-name mb-1">
                <router-link class="strong-text--text" :to="to">
                    {{program.name}}
                </router-link>
            </div>
            <div class="program-description details-text muted--text flex-grow-1">
                {{program.description}}
            </div>
            <div class="d-flex mt-3">
                <div class="category">
                    <v-chip small label color="">{{program.category_name}}</v-chip>
                </div>

                <v-chip v-if="program.is_upcoming" dark label small color="primary" class="font-weight-semibold ms-2">
                    <!-- <v-icon size="18" left class="me-1">mdi-check-circle</v-icon> -->
                    Upcoming
                </v-chip>
                <v-chip v-if="program.subscribed" dark label small color="success" outlined class="font-weight-medium ms-2">
                    <v-icon size="18" left class="me-1">mdi-check-circle</v-icon>
                    Subscribed
                </v-chip>
            </div>
            <!-- <div class="d-flex justify-space-between align-center mt-2">
                <div class="price">
                    <span class="font-weight-semibold primary--text">{{moneyFormat(program.price, true)}}</span>
                    <span class="details--text ml-1">{{program.subscription_type === 'monthly' ? '/month' : ''}}</span>
                </div>
            </div> -->
        </div>
    </v-card>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    data(){
        return {

        }
    },
    props: {
        program: Object,
    },
    computed: {
        to(){
            return {name: 'program', params: {id: this.program.id}};
        },
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods
    }
};
</script>

<style lang="scss" scoped>
.program-card{
    overflow: hidden;
    border-radius: 6px;

    transition: 0.2s ease-in-out all;

    &:hover{
        transform: translateY(-4px);
        box-shadow: 0 4px 13px -1px rgba(0,0,0, .1)!important;
    }

    .program-name{
        font-size: 1rem;
        font-weight: 500;

        a{
            text-decoration: none;

            &:hover{
                opacity: 0.8;
            }
        }
    }
    .program-description{
        
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* number of lines to show */
        -webkit-box-orient: vertical;
    }
    .floating-badges{
        position: absolute;
        top: 0;
        left: 0;
        padding: 0.6rem 0.8rem;
        z-index: 2;
    }
}
</style>
